// extracted by mini-css-extract-plugin
export default {"container":"eP-z","dimension":"fP-z","dimensionLabels":"gP-z"};